import React, { useEffect, useRef, useState } from "react";
import classes from "./Table.module.css";
import VerticalDotsIcon from "../../icons/VerticalDotsIcon";
import { FiPlus } from "react-icons/fi";
import { IoEyeOutline, IoStar } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { AiOutlineEdit } from "react-icons/ai";

const Table = ({
  data,
  groupClick,
  dataType,
  onClick,
  approve,
  decline,
  editItem,
  bookingInfo,
  editCar,
  deleteCar,
  carInfo,
  userInfo,
  editMember,
  deleteMember,
  ticketInfo,
  editTicket,
  deleteTicket,
  columns,
  clickedIndex = () => {},
  setShowDialog = () => {},
  showDialog,
}) => {
  const [dialogPosition, setDialogPosition] = useState({ top: 0, left: 0 });
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const cardRef = useRef(null);
  const iconRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleRowClick = (event, row, index) => {
    if (!isMobile) {
      const { clientX, clientY } = event;
      setDialogPosition({ top: clientY, left: clientX - 425 });
    }
    setSelectedRow(row);
    setShowDialog(true);
    clickedIndex(index);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        cardRef.current &&
        !cardRef.current.contains(event.target) &&
        !iconRef.current.contains(event.target)
      ) {
        setShowDialog(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  const formatHeader = (header) => {
    if (header.includes("ID")) return header;
    return header
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/^./, (str) => str.toUpperCase());
  };

  const renderActionButtons = () => {
    if (dataType === "Bookings") {
      return (
        <button className={classes.actionButton} onClick={bookingInfo}>
          <IoEyeOutline size={17} /> View booking
        </button>
      );
    } else if (dataType === "Cars") {
      return (
        <>
          <button className={classes.actionButton} onClick={editCar}>
            <AiOutlineEdit size={17} /> Edit car
          </button>
          <button className={classes.actionButton} onClick={carInfo}>
            <IoEyeOutline size={17} /> View car
          </button>
          <button className={classes.actionButton} onClick={deleteCar} style={{ color: "#FF3B30" }}>
            <RiDeleteBin6Line size={17} color="#FF3B30" /> Delete car
          </button>
        </>
      );
    } else if (dataType === "Users") {
      return (
        <button className={classes.actionButton} onClick={userInfo}>
          <IoEyeOutline size={17} /> View user
        </button>
      );
    } else if (dataType === "Members") {
      return (
        <>
          <button className={classes.actionButton} onClick={editMember}>
            <AiOutlineEdit size={17} /> Edit member
          </button>
          <button className={classes.actionButton} onClick={deleteMember} style={{ color: "#FF3B30" }}>
            <RiDeleteBin6Line size={17} color="#FF3B30" /> Delete member
          </button>
        </>
      );
    } else if (dataType === "Support") {
      return (
        <>
          <button className={classes.actionButton} onClick={ticketInfo}>
            <IoEyeOutline size={17} /> View ticket
          </button>
          <button className={classes.actionButton} onClick={editTicket}>
            <AiOutlineEdit size={17} /> Mark as closed
          </button>
          <button className={classes.actionButton} onClick={deleteTicket} style={{ color: "#FF3B30" }}>
            <RiDeleteBin6Line size={17} color="#FF3B30" /> Delete ticket
          </button>
        </>
      );
    }
    return (
      <>
        {dataType !== "Transactions" && (
          <button className={classes.actionButton} onClick={dataType === "Withdrawals" && approve}>
            {dataType === "Withdrawals" ? "Approve transaction" : "Send Warning"}
          </button>
        )}
        {dataType !== "Transactions" && (
          <button className={classes.actionButton} onClick={dataType === "Withdrawals" && decline}>
            {dataType === "Withdrawals" ? "Decline transaction" : "Restrict Trading"}
          </button>
        )}
        {(dataType === "Withdrawals" || dataType === "Transactions") && (
          <button className={classes.actionButton} onClick={editItem}>Edit</button>
        )}
      </>
    );
  };

  return (
    <div className={classes.tableDiv}>
      <table style={{ borderCollapse: "collapse", width: "100%", marginBottom: dataType === "Group" && 0 }}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
            {dataType !== "Performing-cars" && <th></th>}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col) => {
                let className = "";
                console.log("Data KEY:", [col.key]);
                console.log("Data in Table component:", [row[col.key]]);
                if (dataType === "Bookings") {
                  if (col.key === "status") {
                    if (row[col.key] === "Pending") className = classes.warningText;
                    else if (row[col.key] === "Confirmed") className = classes.blueText;
                    else if (row[col.key] === "Cancelled") className = classes.dangerText;
                    else if (row[col.key] === "Completed") className = classes.successText;
                  }
                } else if (dataType === "Cars") {
                  if (col.key === "status") {
                    if (row[col.key] === "Rented") className = classes.blueText;
                    else if (row[col.key] === "Maintenance") className = classes.dangerText;
                    else if (row[col.key] === "Available") className = classes.successText;
                  }
                } else if (dataType === "Users" || dataType === "Members") {
                  if (col.key === "status") {
                    className = row[col.key] === "Active" ? classes.successText : classes.disbledText;
                  }
                } else if (dataType === "Support") {
                  if (col.key === "status") {
                    if (row[col.key] === "Open") className = classes.dangerText;
                    else if (row[col.key] === "Closed") className = classes.successText;
                  }
                }

                return (
                  <td
                    className={className}
                    key={col.key}
                    onClick={dataType === "Group trading" ? col.key === "groupID" ? groupClick : () => {} : () => {}}
                    role={dataType === "Group trading" ? col.key === "groupID" ? "button" : "" : ""}
                  >
                    {dataType === "Performing-cars" && col.key === "rating" ? (
                      <div className="d-flex align-items-center gap-1">
                        <IoStar color="var(--primary-color)" />
                        <span>{row[col.key]}</span>
                      </div>
                    ) : (
                      <span>{row[col.key]}</span>
                    )}
                  </td>
                );
              })}
              {dataType !== "Performing-cars" && (
                <td>
                  <div ref={iconRef} className="d-flex align-items-center justify-content-end">
                    {dataType === "User" && row.status === "suspended" && (
                      <p className={classes.dangerText}>Suspended</p>
                    )}
                    {dataType === "Auto" || dataType === "PastRequests" ? (
                      <FiPlus size={20} onClick={() => onClick(rowIndex)} role="button" />
                    ) : (
                      <VerticalDotsIcon onClick={(event) => handleRowClick(event, row, rowIndex)} />
                    )}
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      {showDialog && (
        <>
          {isMobile && (
            <div className={classes.mobileOverlay} onClick={() => setShowDialog(false)} />
          )}
          <div
            ref={cardRef}
            className={`${classes.actionCard} ${isMobile ? classes.mobileActionCard : ""} d-flex flex-column gap-2`}
            style={!isMobile ? {
              position: "absolute",
              top: dialogPosition.top,
              left: dialogPosition.left,
              zIndex: 1000,
            } : undefined}
          >
            {renderActionButtons()}
          </div>
        </>
      )}
    </div>
  );
};

export default Table;
